import {textareaWithVariables_isSpacer} from '../pill/is-spacer'
import {PILL_CLASS} from '../pill/constants'

function setCaret(node: Node, offset: number): void {
    const sel = window.getSelection()
    if (!sel) return
    const r = document.createRange()
    r.setStart(node, offset)
    r.collapse(true)
    sel.removeAllRanges()
    sel.addRange(r)
}

function setCaretAfter(node: Node): void {
    const r = document.createRange()
    r.setStartAfter(node)
    r.collapse(true)
    const sel = window.getSelection()
    sel?.removeAllRanges()
    sel?.addRange(r)
}

function setCaretBefore(node: Node): void {
    const r = document.createRange()
    r.setStartBefore(node)
    r.collapse(true)
    const sel = window.getSelection()
    sel?.removeAllRanges()
    sel?.addRange(r)
}

// Land the caret just after a pill — inside its trailing zero-width
// spacer if present (small caret), else right after the pill node.
function landAfter(pill: HTMLElement): void {
    const next = pill.nextSibling
    if (next && textareaWithVariables_isSpacer(next)) {
        setCaret(next, (next.textContent || '').length)
    } else {
        setCaretAfter(pill)
    }
}

// Land the caret just before a pill — inside its leading zero-width
// spacer if present (small caret), else right before the pill node.
function landBefore(pill: HTMLElement): void {
    const prev = pill.previousSibling
    if (prev && textareaWithVariables_isSpacer(prev)) {
        setCaret(prev, 0)
    } else {
        setCaretBefore(pill)
    }
}

// Clicking a pill (chip) should move the caret right next to it — left
// half of the chip lands the caret just before it, right half just
// after. Browsers resolve clicks on an atomic `contenteditable="false"`
// element inconsistently, so we intercept on mousedown (before the
// browser places its own caret) and position it ourselves.
// Returns true if the click was on a pill and was handled.
export function textareaWithVariables_handlePillMouseDown(e: MouseEvent, editor: HTMLElement): boolean {
    const target = e.target as Element | null
    const pill = target?.closest(`.${PILL_CLASS}`) as HTMLElement | null
    if (!pill || !editor.contains(pill)) {
        return false
    }

    e.preventDefault()
    editor.focus()

    const rect = pill.getBoundingClientRect()
    const clickedLeftHalf = e.clientX < rect.left + rect.width / 2

    if (clickedLeftHalf) {
        landBefore(pill)
    } else {
        landAfter(pill)
    }

    return true
}
